import * as Actions from './page-header.actions';
import { PageHeaderStateInterface } from './page-header.model';

const initialState: PageHeaderStateInterface = {
  isFilterBarVisible: true,
  isPageConfigHidden: false,
};

export function pageHeaderReducer(
  state: PageHeaderStateInterface = initialState,
  action: Actions.PageHeaderActions,
): PageHeaderStateInterface {
  switch (action.type) {

    case Actions.UPDATE_FILTER_BAR_VISIBILITY:
      return {
        ...state,
        isFilterBarVisible: action.isVisible,
      };
    case Actions.UPDATE_PAGE_HEADER_BUTTONS_VISIBILITY:
      return {
        ...state,
        ...action.isPageHeaderButtonsVisible,
      };
    case Actions.RESET_STORE_TO_DEFAULT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
